import {Injectable} from '@angular/core';
import {Campus} from '../../model/Campus';

@Injectable({
  providedIn: 'root',
})
export class DataLoaderMockService {

  constructor() {
  }

  public async FetchCampusList(): Promise<Campus[]> {
    const campusList: Campus[] = [];

    for (let i = 0; i < 100; i++) {
      campusList.push(new Campus({
        id: i,
      }));
    }

    return Promise.resolve(campusList);
  }

  public async FetchCampus(id: string): Promise<Campus> {
    if (id === 'BugDAzpfM3GbcvXFET2K') {
      return Promise.resolve(new Campus({
        name: 'dgrdd2',
      }));
    } else {
      return Promise.reject('Campus not found. ' + id);
    }
  }
}
